import type { LanguageOption } from 'src/utils/languages';
import type { QuestionData } from '../types';
import { fingerprintFormTranslateSource } from './fingerprintFormTranslateSource';
import { localeHasFormTranslationRows } from './localeHasFormTranslationRows';
import { DEFAULT_FORM_EDITING_LOCALE } from './localizedQuestionFieldHelpers';

export function seedFormAutoTranslateLastFingerprintFromHydratedQuestions(
  lastAutoTranslateFingerprintByLocale: Record<string, string>,
  questions: QuestionData[],
  categoryName: string,
  categoryDescription: string,
  selectedLanguages: LanguageOption[],
): void {
  const fp = fingerprintFormTranslateSource(
    questions,
    categoryName,
    categoryDescription,
  );
  for (const lang of selectedLanguages) {
    if (lang.value === DEFAULT_FORM_EDITING_LOCALE) continue;
    if (!localeHasFormTranslationRows(questions, lang.value)) continue;
    if (lastAutoTranslateFingerprintByLocale[lang.value] !== undefined) {
      continue;
    }
    lastAutoTranslateFingerprintByLocale[lang.value] = fp;
  }
}
